<template>
  <div class="lot-relocations">
    <div class="card-header bg-default">
      <router-link :to="'/fleet/vehicles/' + lotRelocation.Car.uuid">
        {{ lotRelocation.Car.dropdownLabel }}
      </router-link>
    </div>
    <div class="list-group list-group-flush">
      <div class="list-group-item" v-if="lotRelocation.cancelled">
        <p class="alert alert-danger">
          This relocation has been cancelled.
        </p>
      </div>
      <div class="list-group-item">
        <strong><span class="fa fa-sign-out-alt"></span> From: </strong>
        <router-link :to="'/fleet/lots/' + lotRelocation.OriginalLot.uuid">
          {{ lotRelocation.OriginalLot.dropdownLabel }}
        </router-link>
      </div>
      <div class="list-group-item">
        <strong><span class="fa fa-sign-in-alt"></span> To: </strong>
        <router-link :to="'/fleet/lots/' + lotRelocation.Lot.uuid">
          {{ lotRelocation.Lot.dropdownLabel }}
        </router-link>
      </div>
      <div class="list-group-item" v-if="lotRelocation.Reservation && !lotRelocation.Reservation.maintenance">
        <strong>Reservation ID: </strong>
        <router-link :to="'/fleet/reservations/' + lotRelocation.Reservation.uuid">
          {{ lotRelocation.Reservation.reservationId }}
        </router-link>
      </div>
      <div class="list-group-item" v-if="lotRelocation.AdminResponsibleUuid">
        <strong><span class="fa fa-user-circle"></span> Scheduled By: </strong>
        <router-link :to="'/membership/members/' + lotRelocation.AdminResponsible.uuid">
          {{ lotRelocation.AdminResponsible.dropdownLabel }}
        </router-link>
      </div>
      <div class="card-body row">
        <div class="col-sm-7">
          <p>
            <strong>Start Date: </strong> {{ lotRelocation.startDate | date_format(lotRelocation.Lot.timezone) }}<br/>
            <strong>End Date: </strong> {{ lotRelocation.endDate | date_format(lotRelocation.Lot.timezone) }}
          </p>
          <p v-if="lotRelocation.permanent">
            <strong>Relocation Buffer: </strong> {{ lotRelocation.buffer || 0 }} minutes
          </p>
          <p>
            <strong>Relocation Complete: </strong>
            <span :class="new Date() > new Date(lotRelocation.endDate) ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></span>
          </p>
          <p>
            <strong>Permanent Relocation: </strong>
            <span :class="lotRelocation.permanent ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></span>
          </p>
          <template v-if="lotRelocation.Reservation && lotRelocation.Reservation.maintenance">
            <p>
              <strong>Reservation ID: </strong>
              <router-link :to="'/fleet/reservations/' + lotRelocation.Reservation.uuid">
                {{ lotRelocation.Reservation.reservationId }}
              </router-link>
            </p>
            <p v-if="lotRelocation.ReturnReservation && lotRelocation.ReturnReservation.maintenance">
              <strong>Return Reservation ID: </strong>
              <router-link :to="'/fleet/reservations/' + lotRelocation.ReturnReservation.uuid">
                {{ lotRelocation.ReturnReservation.reservationId }}
              </router-link>
            </p>
          </template>
        </div>
        <div class="col-sm-5">
          <img style="max-width: 100%;" :src="googleMapSrc"/>
        </div>
      </div>
    </div>
    <div v-if="new Date() < new Date(lotRelocation.endDate) && (lotRelocation.Reservation && lotRelocation.Reservation.maintenance)" class="card-footer text-right">
      <router-link class="btn btn-primary" :to="'/fleet/relocate/edit/' + lotRelocation.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-danger" @click="cancelRelocation(lotRelocation)">
        <span class="fa fa-ban fa-fw"></span> Cancel
      </button>
      <button v-if="new Date() > new Date(lotRelocation.startDate)" class="btn btn-success" @click="completeRelocation(lotRelocation)">
        <span class="fa fa-check fa-fw"></span> Complete Relocation
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { CANCEL_LOT_RELOCATION, COMPLETE_LOT_RELOCATION } from '@/vuex/types'
  import Util from '../../../server/util'
  export default {
    name: 'LotRelocation',
    props: {
      object: {
        type: Object
      }
    },
    computed: {
      lotRelocation () {
        return {
          ...this.object
        }
      },
      googleMapSrc () {
        let distance = Util.calculateDistance({
          latitude: this.lotRelocation.OriginalLot.latitude,
          longitude: this.lotRelocation.OriginalLot.longitude
        }, {
          latitude: this.lotRelocation.Lot.latitude,
          longitude: this.lotRelocation.Lot.longitude
        }) / 1000
        let zoom = 15
        if (distance > 1 && distance <= 4) {
          zoom = 14
        } else if (distance > 4 && distance < 18) {
          zoom = 11
        } else if (distance >= 18 && distance < 40) {
          zoom = 10
        } else if (distance >= 40) {
          zoom = 8
        }
        return 'http://maps.googleapis.com/maps/api/staticmap?center=' +
        this.midPoint.lat + ',' + this.midPoint.lng +
        '&size=275x275&zoom=' + zoom + '&markers=color:0x2196F3%7Clabel:F%7C' +
        this.lotRelocation.OriginalLot.latitude + ',' +
        this.lotRelocation.OriginalLot.longitude +
        '&markers=color:0xF44336%7Clabel:T%7C' + this.lotRelocation.Lot.latitude +
        ',' + this.lotRelocation.Lot.longitude +
        '&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'
      },
      midPoint () {
        return Util.middlePoint(
          this.lotRelocation.OriginalLot.latitude,
          this.lotRelocation.OriginalLot.longitude,
          this.lotRelocation.Lot.latitude,
          this.lotRelocation.Lot.longitude
        )
      }
    },
    methods: {
      ...mapActions([
        CANCEL_LOT_RELOCATION,
        COMPLETE_LOT_RELOCATION
      ]),
      async cancelRelocation (lotRelocation) {
        await this[CANCEL_LOT_RELOCATION](lotRelocation)
      },
      async completeRelocation (lotRelocation) {
        await this[COMPLETE_LOT_RELOCATION](lotRelocation)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/LotRelocations.vue